module.exports = __webpack_public_path__ + "img/基础信息.3ee27c94.svg";